import { render, staticRenderFns } from "./QuestionSourceEditor.vue?vue&type=template&id=3307cd5e&scoped=true&"
import script from "./QuestionSourceEditor.vue?vue&type=script&lang=ts&"
export * from "./QuestionSourceEditor.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionSourceEditor.vue?vue&type=style&index=0&id=3307cd5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3307cd5e",
  null
  
)

export default component.exports